// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1XRke","select":"Header_select__23RYD","clinic":"Header_clinic__3FCFp"};